import { IBreed } from '@jumpstart/core';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { getAuth, signOut } from 'firebase/auth';
import { collection, getFirestore, Query } from 'firebase/firestore';
import React, { MouseEvent, useState } from 'react';
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { app } from '../core/firebase';
import { BreedsContext, useAdminProfile } from '../core/hooks';
import { IMAGE_PLACEHOLDER } from '../core/utils';
import { Logo } from '../widgets/logo';

export default function AdminOutlet() {
  const [breeds] = useCollectionDataOnce<IBreed>(collection(getFirestore(app), 'breeds') as Query<IBreed>);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const adminProfile = useAdminProfile();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        setAnchorEl(null);
        navigate('/signin');
      })
      .catch((err: Error) => {
        setAnchorEl(null);
        console.error(err);
      });
  };
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (

    <BreedsContext.Provider value={breeds ? breeds : []}>
      <div style={{ flexGrow: 1, marginBottom: '24px' }}>
        <AppBar position="static">
          <Toolbar>
            <div style={{ marginRight: 8, flexGrow: 1 }}>
              {location.pathname.indexOf('/admin/wh') > -1 ? <img src={`${process.env.PUBLIC_URL}/assets/wh/welcome-home-logo-white.png`} alt="Logo" style={{ width: 90 }}/> : <Logo/> }
            </div>
            <Typography variant="subtitle1" style={{ color: '#fff' }}>Admin Dashboard{adminProfile && adminProfile.firstName && ' - ' + adminProfile.firstName}</Typography>
            <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              <MenuIcon style={{ color: '#fff' }}/>
            </IconButton>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={!!anchorEl}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose} component={Link} to="/admin/events">Events</MenuItem>
              <MenuItem onClick={handleClose} component={Link} to="/admin/booking">Booking</MenuItem>
              <MenuItem onClick={handleClose} component={Link} to="/admin/scout">Messages</MenuItem>
              <MenuItem onClick={handleClose} component={Link} to="/admin/wh">WH</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Toolbar>
        </AppBar>
      </div>
      <Container maxWidth="xl">
        <Outlet/>
      </Container>
    </BreedsContext.Provider>
  );
}
